import { useState, useEffect } from 'react';
import api from '../lib/api';

/**
 * <AuthImg> carica un'immagine protetta da Bearer token usando axios+blob.
 * Sostituisce <img src={url}> nelle pagine dove src è un endpoint autenticato.
 */
export default function AuthImg({ url, alt = '', className = '', onError, cacheBust }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;
    const load = async () => {
      try {
        // url può essere passato come absoluto (`https://...`) o relativo all'API
        const path = url.startsWith('http') ? url.replace(api.defaults.baseURL, '') : url;
        const r = await api.get(path, { responseType: 'blob', params: cacheBust ? { t: cacheBust } : undefined });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(r.data);
        setSrc(objectUrl);
      } catch (e) {
        if (onError) onError(e);
      }
    };
    load();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, cacheBust, onError]);
  if (!src) return <div className={`${className} bg-slate-100 animate-pulse`} aria-label={alt} />;
  return <img src={src} alt={alt} className={className} style={{ objectFit: 'cover', objectPosition: 'center' }} />;
}
